import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ShiftService {
  constructor(private http: HttpClient) {}

  createShift(payload: any) {
    return this.http.post(`${environment.apiUrl}/shift/create`, payload);
  }

  createBulkShifts(payload: any) {
    return this.http.post(`${environment.apiUrl}/shift/bulk-create`, payload);
  }

  getShiftsByNurseId(nurseId: string) {
    return this.http.get(`${environment.apiUrl}/shift/nurse/${nurseId}`);
  }

  getPagedShift(payload: {
    pageIndex: number;
    pageSize: number;
    sortField?: string;
    sortOrder?: number;
    startDate?: string;
    endDate?: string;
  },nurseId: string) {
    const requestPayload = {
      ...payload,
    };
    return this.http.post(
      `${environment.apiUrl}/shift/nurse/${nurseId}/paged`,requestPayload
    );
  }

  getPagedClientShift(payload: {
    pageIndex: number;
    pageSize: number;
    sortField?: string;
    sortOrder?: number;
    startDate?: string;
    endDate?: string;
  },clientId: string) {
    const requestPayload = {
      ...payload,
    };
    return this.http.post(
      `${environment.apiUrl}/shift/client/${clientId}/paged`,requestPayload
    );
  }

  updateShift(shiftId: string, payload: any) {
    return this.http.put(`${environment.apiUrl}/shift/update/${shiftId}`, payload);
  }

  getShiftsByDateRange(
    startDate: string,
    endDate: string,
    includeArchived: boolean = false,
  ) {
    return this.http.post(`${environment.apiUrl}/shift/get-by-date-range`, {
      startDate,
      endDate,
      includeArchived,
    });
  }

  getShiftById(shiftId: string) {
    return this.http.get(`${environment.apiUrl}/shift/${shiftId}`);
  }

  archiveShift(shiftId: string) {
    return this.http.delete(`${environment.apiUrl}/shift/${shiftId}`);
  }

  unarchiveShift(shiftId: string) {
    return this.http.patch(
      `${environment.apiUrl}/shift/${shiftId}/unarchive`,
      {},
    );
  }

  getMonthlyShiftsByNurseIdPaginated(nurseId: string, payload: {
    pageIndex: number;
    pageSize: number;
    sortField?: string;
    sortOrder?: number;
  }) {
    const requestPayload = {
      ...payload,
    };
    return this.http.post(
      `${environment.apiUrl}/shift/nurse/${nurseId}/monthly/paged`, requestPayload
    );
  }

  getNurseShiftsBySpecificMonth(nurseId: string, year: number, month: number) {
    return this.http.get(`${environment.apiUrl}/shift/nurse/${nurseId}/month/${year}/${month}`);
  }

  getMonthlyShiftsByClientIdPaginated(clientId: string, payload: {
    pageIndex: number;
    pageSize: number;
    sortField?: string;
    sortOrder?: number;
  }) {
    const requestPayload = {
      ...payload,
    };
    return this.http.post(
      `${environment.apiUrl}/shift/client/${clientId}/monthly/paged`, requestPayload
    );
  }

  getClientShiftsBySpecificMonth(clientId: string, year: number, month: number) {
    return this.http.get(`${environment.apiUrl}/shift/client/${clientId}/month/${year}/${month}`);
  }
}
